import PropTypes from 'prop-types';
import React from 'react';

import { BadgeTypes } from '../../../../constants/Badge';
import { createBEM } from '../../../../lib/utils/css';
import Badge from '../../Badge/Badge';
import RowItemText from '../RowItemText';

import RowItemThirdText from './RowItemThirdText';

import './RowItemCenterColumn.scss';

class RowItemCenterColumn extends React.PureComponent {
  static propTypes = {
    isLargeText: PropTypes.bool,
    useLightTheme: PropTypes.bool,
    useDarkTheme: PropTypes.bool,
    isFullRowLink: PropTypes.bool,
    isRowHovered: PropTypes.bool,

    mainText: PropTypes.string,
    mainTextModifier: PropTypes.node,
    mainTextUrl: PropTypes.string,
    mainTextOnclick: PropTypes.func,
    qaMainText: PropTypes.string,
    isUnavailable: PropTypes.bool,

    secondText: PropTypes.node,
    secondTextUrl: PropTypes.string,
    secondTextOnclick: PropTypes.func,
    qaSecondText: PropTypes.string,
    secondTextModifier: PropTypes.string,
    removeSecondTextUrl: PropTypes.bool,

    thirdText: PropTypes.string,
    thirdTextUrl: PropTypes.string,
    thirdTextOnclick: PropTypes.func,
    qaThirdText: PropTypes.string,
    thirdTextModifier: PropTypes.string,
    rightColChild: PropTypes.node,
    qaRightColChild: PropTypes.string,
    isRowSmall: PropTypes.bool,
    isRightColPersistent: PropTypes.bool,
    hasTakeoverModes: PropTypes.bool,
    hasCuratedModes: PropTypes.bool,
  };

  render() {
    const classNames = createBEM('RowItemCenterColumn', {
      hovered: this.props.isRowHovered,
      largeText: this.props.isLargeText,
      light: this.props.useLightTheme,
      dark: this.props.useDarkTheme,
      fullRowLink: this.props.isFullRowLink,
    });

    const mainTextClassNames = createBEM('RowItemCenterColumn__mainText', {
      disable: this.props.isUnavailable,
    });

    const modesBadgeProps = {
      isBlue: true,
      isInline: true,
    };

    const badgeBasedOnMode = () => {
      if (this.props.hasCuratedModes) {
        return <Badge {...modesBadgeProps} badgeType={BadgeTypes.CURATED_MODES} />;
      } else if (this.props.hasTakeoverModes) {
        return <Badge {...modesBadgeProps} badgeType={BadgeTypes.TAKEOVER_MODES} />;
      }
      return null;
    };

    return (
      <div className={classNames}>
        <RowItemText
          className={mainTextClassNames}
          text={this.props.mainText}
          href={this.props.mainTextUrl}
          onClick={this.props.mainTextOnclick}
          contentModifer={this.props.mainTextModifier}
          qaTag={this.props.qaMainText}
          isDisabled={this.props.isUnavailable}
        />

        <RowItemText
          className='RowItemCenterColumn__secondText'
          text={this.props.secondText}
          href={this.props.secondTextUrl}
          onClick={this.props.secondTextOnclick}
          contentModifer={this.props.secondTextModifier}
          qaTag={this.props.qaSecondText}
          badge={badgeBasedOnMode()}
        />

        <RowItemThirdText
          thirdText={this.props.thirdText}
          thirdTextUrl={this.props.thirdTextUrl}
          thirdTextOnclick={this.props.thirdTextOnclick}
          qaThirdText={this.props.qaThirdText}
          thirdTextModifier={this.props.thirdTextModifier}
          rightColChild={this.props.rightColChild}
          qaRightColChild={this.props.qaRightColChild}
          isRowSmall={this.props.isRowSmall}
          isRightColPersistent={this.props.isRightColPersistent}
        />
      </div>
    );
  }
}

export default RowItemCenterColumn;
